"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppMessage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_native_1 = require("react-native");
const native_base_1 = require("native-base");
const AppMessage_1 = __importDefault(require("../component/AppMessage"));
const useAppMessage = () => {
    const toast = react_native_1.Platform.OS === 'web' ? native_base_1.Toast : (0, native_base_1.useToast)();
    const showNotification = (title, description, status, duration) => {
        if (!toast.isActive("talkAlert")) {
            toast.show({
                id: "talkAlert",
                duration: duration || 3500,
                placement: "top",
                zIndex: 999,
                render: ({ id }) => {
                    return ((0, jsx_runtime_1.jsx)(AppMessage_1.default, { id: id, title: title, status: status, description: description, variant: "top-accent" }));
                },
            });
        }
    };
    return {
        showNotification,
    };
};
exports.useAppMessage = useAppMessage;
